import { create } from "zustand";

interface ProcessingState {
  processing: boolean;
  setProcessing: (value: boolean) => void;
}

export const useProcessingStore = create<ProcessingState>()((set) => ({
  processing: false,
  setProcessing: (value: boolean) => set((state) => ({ processing: value })),
}));
